import type { AssetRef, LegacyAudienceConfig } from '@/domain/audience/types'
import { audienceEnvironment } from '@/core/runtime/environment'

interface LegacyManifest {
  eventId: string
  configUrl: string
  checksum: string
}

function assertPublicCdnUrl(value: string): string {
  const url = new URL(value)
  if (url.origin !== audienceEnvironment.cdnBase || url.protocol !== 'https:') {
    throw new Error('旧版配置地址不属于当前构建环境')
  }
  return url.href
}

export async function loadLegacyAudience(stadiumId: string): Promise<LegacyAudienceConfig> {
  if (!/^\d{16,20}$/.test(stadiumId)) throw new Error('场馆参数无效')
  const manifestUrl = `${audienceEnvironment.cdnBase}/config/${stadiumId}/audience/manifest.json`
  const manifestResponse = await fetch(manifestUrl, { cache: 'no-store' })
  if (!manifestResponse.ok) throw new Error('未能读取当前活动发布配置')
  const manifest = (await manifestResponse.json()) as LegacyManifest
  const configResponse = await fetch(assertPublicCdnUrl(manifest.configUrl), { cache: 'no-store' })
  if (!configResponse.ok) throw new Error('未能读取当前活动内容')
  const config = (await configResponse.json()) as LegacyAudienceConfig
  config._runtime = { eventId: String(manifest.eventId || ''), checksum: manifest.checksum }
  return config
}

export function resolveAssetUrl(asset: AssetRef | string | null | undefined): string {
  if (typeof asset === 'string') return asset
  if (!asset) return ''
  const source = asset.asset || asset
  const displayVariant = asset.displayVariant === 'original' || source.displayVariant === 'original' ? 'original' : 'hd'
  return displayVariant === 'original'
    ? source.originalUrl || source.hdUrl || ''
    : source.hdUrl || source.originalUrl || ''
}
